import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createUserCardBlock } from "../../utils/layoutBlockHelpers";
import { createPBlock } from "../../utils/textBlocksHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "Testimonial1",
  props: {
    userCard: {
      prop: "children",
      type: "children",
      value: [
        createUserCardBlock({
          image: {
            signedId: "",
          },
          header: "Aisha Meher",
          description: "Non-Profit Leader",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: '"This program gave me the confidence to step into a leadership role I would have previously thought was beyond my capabilities. Life changing!"',
        }),
      ],
    },
  },
};

export const createTestimonial1Block = ({
  userCard = { signedId: "", placeholder: "", header: "", description: "" },
  content = "",
}: {
  userCard?: {
    signedId: string;
    placeholder: string;
    header: string;
    description: string;
  };
  content?: string;
}): BaseBlock => ({
  ...defaultData,
  id: uuidv4(),
  props: {
    ...defaultData.props,
    userCard: {
      ...defaultData.props.userCard,
      type: "children",
      prop: "children",
      value: [
        createUserCardBlock({
          image: {
            signedId: userCard.signedId,
            placeholder: userCard.placeholder,
          },
          header: userCard.header,
          description: userCard.description,
        }),
      ],
    },
    content: {
      ...defaultData.props.content,
      type: "children",
      prop: "children",
      value: [
        createPBlock({
          text: content,
        }),
      ],
    },
  },
});
